// Every province and territory, keyed by name or abbreviation (English and French) after
// normalizeProvince. Provinces that span time zones use the zone of their main cities.
const TIME_ZONE_BY_PROVINCE: Record<string, string> = {
  // British Columbia
  britishcolumbia: 'America/Vancouver',
  colombiebritannique: 'America/Vancouver',
  bc: 'America/Vancouver',
  cb: 'America/Vancouver',
  // Alberta
  alberta: 'America/Edmonton',
  ab: 'America/Edmonton',
  alb: 'America/Edmonton',
  alta: 'America/Edmonton',
  // Saskatchewan (no daylight saving)
  saskatchewan: 'America/Regina',
  sk: 'America/Regina',
  sask: 'America/Regina',
  // Manitoba
  manitoba: 'America/Winnipeg',
  mb: 'America/Winnipeg',
  man: 'America/Winnipeg',
  // Ontario
  ontario: 'America/Toronto',
  on: 'America/Toronto',
  ont: 'America/Toronto',
  // Quebec
  quebec: 'America/Toronto',
  qc: 'America/Toronto',
  que: 'America/Toronto',
  pq: 'America/Toronto',
  // New Brunswick
  newbrunswick: 'America/Moncton',
  nouveaubrunswick: 'America/Moncton',
  nb: 'America/Moncton',
  // Nova Scotia
  novascotia: 'America/Halifax',
  nouvelleecosse: 'America/Halifax',
  ns: 'America/Halifax',
  ne: 'America/Halifax',
  // Prince Edward Island
  princeedwardisland: 'America/Halifax',
  ileduprinceedouard: 'America/Halifax',
  pe: 'America/Halifax',
  pei: 'America/Halifax',
  ipe: 'America/Halifax',
  // Newfoundland and Labrador
  newfoundlandandlabrador: 'America/St_Johns',
  terreneuveetlabrador: 'America/St_Johns',
  newfoundland: 'America/St_Johns',
  nl: 'America/St_Johns',
  nfld: 'America/St_Johns',
  tnl: 'America/St_Johns',
  // Yukon (no daylight saving)
  yukon: 'America/Whitehorse',
  yt: 'America/Whitehorse',
  yn: 'America/Whitehorse',
  // Northwest Territories (same rules as Edmonton)
  northwestterritories: 'America/Edmonton',
  territoiresdunordouest: 'America/Edmonton',
  nt: 'America/Edmonton',
  nwt: 'America/Edmonton',
  tno: 'America/Edmonton',
  // Nunavut
  nunavut: 'America/Iqaluit',
  nu: 'America/Iqaluit',
  nvt: 'America/Iqaluit',
  nun: 'America/Iqaluit',
};

// Drops accents, case and punctuation: "(N.-É.)" -> "ne", "Nouvelle-Écosse" -> "nouvelleecosse"
function normalizeProvince(province: string): string {
  return province
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z]/g, '');
}

export const buildTimeZone = (province: string) => {
  const timeZone = TIME_ZONE_BY_PROVINCE[normalizeProvince(province ?? '')];

  if (!timeZone) {
    console.error(
      `Province ${province} not found. Defaulting to PST time zone.`
    );
    return 'America/Vancouver';
  }

  return timeZone;
};
